import React, { FC } from "react";
import { Button, Modal, Typography } from "antd";
import { CheckOutlined } from "@ant-design/icons";
import Title from "antd/es/typography/Title";

type NewConfirmationModalProps = {
  open: boolean;
  title: string;
  handleCancel: () => void;
  handleSave: () => void;
  isLoading?: boolean;
  content?: any; 
};

const { Text } = Typography;

const NewConfirmationModal: FC<NewConfirmationModalProps> = (
  props
) => {
  return (
    <Modal
      open={props?.open}
      onCancel={props?.handleCancel}
      footer={null}
      closable={false}
      bodyStyle={{ textAlign: "center" }}
      width={600}
    >
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          border: "2px solid rgb(0, 76, 143)",
          borderRadius: "50%",
          padding: "6px",
          boxShadow: "0 24px 24px rgba(0, 0, 0, 0.15)",
          backgroundColor: " #ffffff",
          marginBottom: "8px",
        }}
      >
        <CheckOutlined style={{ fontSize: "14px", color: "rgb(0, 76, 143)" }} />
      </div>
      <Title level={3} style={{ marginTop: 16 }}>
        CONFIRM
      </Title>
      <Text style={{ display: "block", marginBottom: 24 }}>{props?.title}</Text>
      {props.content && (
        <div style={{ marginBottom: 24 }}>{props.content}</div>
      )}
      <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
        <Button
          onClick={props?.handleCancel}
          type="default"
          style={{
            borderColor: "#004C8F",
            color: "#004C8F",
            boxShadow: "0px 2px 8px 0px #00000040",
            minWidth: 100,
          }}
        >
          NO
        </Button>
        <Button
          onClick={props?.handleSave}
          type="primary"
          style={{
            backgroundColor: "#004C8F",
            color: "#fff",
            boxShadow: "0px 2px 8px 0px #00000040",
            minWidth: 100,
          }}
          loading={props?.isLoading}
        >
          YES
        </Button>
      </div>
    </Modal>
  );
};

export default NewConfirmationModal;
